import { render, staticRenderFns } from "./courseHeatRanking1.vue?vue&type=template&id=4f161a60&scoped=true"
import script from "./courseHeatRanking1.vue?vue&type=script&lang=js"
export * from "./courseHeatRanking1.vue?vue&type=script&lang=js"
import style0 from "./courseHeatRanking1.vue?vue&type=style&index=0&id=4f161a60&prod&lang=scss&scoped=true"
import style1 from "./courseHeatRanking1.vue?vue&type=style&index=1&id=4f161a60&prod&lang=less&scoped=true"
import style2 from "./courseHeatRanking1.vue?vue&type=style&index=2&id=4f161a60&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.17.21_prettier@2.8.8_vue-temp_pgqv4bjfw4n43uthtcnbh5tcie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f161a60",
  null
  
)

export default component.exports